<template>
  <div class="mm-page-main" v-loading="mso_id==0" :element-loading-text="'請先添加牌照MSO和門店'" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)">
    <div v-if="!show_info" class="page-header">
      <div class="page-title">會員列表</div>
      <div>
        <el-link @click="gotoruter('/AddCustomer')" type="primary"><i class="el-icon-circle-plus"></i>添加會員</el-link>
      </div>
    </div>
    <search :form="form" @submit="getdata" v-if="!show_info"></search>
    <div v-if="!show_info" class="pagemain">
      <div v-loading="loading" class="pagetablebox">
        <el-table :data="data" border :header-cell-style="{background:'#FAFAFA'}">
          <el-table-column width="200" label="會員編號" align="center">
            <template slot-scope="scope">
              <div class="phonecel">會員編號</div>
              <div v-if="scope.row.type == 0"><span>P</span><span>{{scope.row.customer_num}}</span></div>
              <div v-else-if="scope.row.type == 1"><span>C</span><span>{{scope.row.customer_num}}</span></div>
              <div v-else-if="scope.row.type == 2"><span>H</span><span>{{scope.row.customer_num}}</span></div>
            </template>
          </el-table-column>
          <el-table-column prop="old_customer_num" label="舊會員編號" align="center">
            <template slot-scope="scope">
              <div class="phonecel">舊會員編號</div>
              <span>{{scope.row.old_customer_num}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="card" label="證件號碼/B.R." align="center">
            <template slot-scope="scope">
              <div class="phonecel">證件號碼/B.R.</div>
              <span v-if="scope.row.type==0">{{scope.row.card}}</span>
              <span v-else>{{scope.row.company_card}}</span>
            </template>
          </el-table-column>

          <el-table-column prop="company_card_date" label="B.R.有效期" align="center">
            <template slot-scope="scope">
              <div class="phonecel">B.R.有效期</div>
              <span>{{scope.row.company_card_date}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="姓名/公司名稱" align="center">
            <template slot-scope="scope">
              <div class="phonecel">姓名/公司名稱</div>
              <span>{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="ename" label="英文名稱" align="center">
            <template slot-scope="scope">
              <div class="phonecel">英文名稱</div>
              <span>{{scope.row.ename}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="account_name" label="結餘" align="center"></el-table-column> -->
          <el-table-column prop="phone" label="電話號碼" align="center">
            <template slot-scope="scope">
              <div class="phonecel">電話號碼</div>
              <span>{{scope.row.phone}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="remarks" label="備註" align="center">
            <template slot-scope="scope">
              <div class="phonecel">備註</div>
              <span>{{scope.row.remarks}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="addtime" label="加入時間" align="center">
            <template slot-scope="scope">
              <div class="phonecel">加入時間</div>
              <span>{{scope.row.addtime}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="balance" label="本月交易次數" align="center"></el-table-column> -->
          <!-- <el-table-column prop="balance" label="本月交易金額(HKD)" align="center"></el-table-column> -->
          <el-table-column prop="risk_level" label="風險評估" align="center">
            <template slot-scope="scope">
              <div class="phonecel">風險評估</div>
              <div>
                <el-select @change="changerisk(scope.row.id,scope.row.risk_level)" :class="scope.row.risk_level==0?'select-green':(scope.row.risk_level==1?'select-orange':'select-red')" v-model="scope.row.risk_level" placeholder="請選擇">
                  <el-option style="color:green;" label="低" value="0"></el-option>
                  <el-option style="color:orange;" label="中" value="1"></el-option>
                  <el-option style="color:red;" label="高" value="2"></el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="狀態" align="center">
            <template slot-scope="scope">
              <div class="phonecel">狀態</div>
              <div>
                <el-select @change="changestatus(scope.row.id,scope.row.status)" :class="scope.row.status==0?'select-green':(scope.row.status==1?'select-orange':'select-red')" v-model="scope.row.status" placeholder="請選擇">
                  <el-option style="color:green;" label="Active 有效" value="0"></el-option>
                  <el-option style="color:orange;" label="Suspended 暫停交易" value="1"></el-option>
                  <el-option style="color:red;" label="Terminated 終止業務關係" value="2"></el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <div class="phonecel">操作</div>
              <div>
                <el-link @click="customer_id=scope.row.id;show_info=true;" class="mr15"><i class="el-icon-circle-plus-outline"></i>詳細</el-link>
                <el-link @click="customer_id=scope.row.id;show_info=true;edit_info=true;"><i class="el-icon-edit-outline"></i>編輯</el-link>
                <el-link @click="del(scope.row.id)"><i class="el-icon-delete"></i>刪除</el-link>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page-bottom">
        <div>
          Total: {{pager.p_count}} 個會員
        </div>
        <div></div>
        <div>
          <el-pagination background @size-change="changesize" @current-change="changepage" :current-page="pager.p_now" :page-sizes="[5, 10, 20, 50]" :page-size="parseInt(pager.p_size)" layout="sizes, prev, pager, next, jumper" :total="pager.p_count">
          </el-pagination>
        </div>
      </div>
    </div>
    <div v-if="show_info">
      <div class="mm-row mb15 flex-center">
        <div class="page-title" v-if="!edit_info">會員詳情</div>
        <div class="page-title" v-if="edit_info">編輯會員</div>
        <el-button type="primary" @click="show_info=false;edit_info=false;getdata()">返回<i class="el-icon-left"></i></el-button>
      </div>
      <div v-if="!edit_info">
        <el-tabs v-model="activename" @tab-click="handleClick">
          <el-tab-pane label="會員資料" name="info">
            <div style="margin:-20px">
              <customerinfo :customer_id="customer_id"></customerinfo>
            </div>
          </el-tab-pane>
          <el-tab-pane label="交易記錄" name="records">
            <div style="margin:-20px">
              <orderlist class="mt15" v-if="activename=='records'" :customer_id="customer_id"></orderlist>
            </div>
          </el-tab-pane>
          <el-tab-pane label="現金結餘" name="cashbalance">
            <div style="margin:-20px">
              <customercashaccount class="mt15" v-if="activename=='cashbalance'" :customer_id="customer_id"></customercashaccount>
            </div>
          </el-tab-pane>
          <el-tab-pane label="現金結餘記錄" name="balancerecords">
            <div style="margin:-20px">
              <cashaccountlogs class="mt15" v-if="activename=='balancerecords'" :customer_id="customer_id"></cashaccountlogs>
            </div>
          </el-tab-pane>
          <el-tab-pane label="銀行結餘" name="bankbalance">
            <div style="margin:-20px">
              <customerbankaccount class="mt15" v-if="activename=='bankbalance'" :customer_id="customer_id"></customerbankaccount>
            </div>
          </el-tab-pane>
          <el-tab-pane label="銀行結餘記錄" name="balancebankrecords">
            <div style="margin:-20px">
              <bankaccountlogs class="mt15" v-if="activename=='balancebankrecords'" :customer_id="customer_id"></bankaccountlogs>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <editcustomer v-if="edit_info" :customer_id="customer_id"> </editcustomer>
    </div>
  </div>
</template>

<script>
import search from "./components/Search.vue";
import orderlist from "./components/OrderList.vue";
import customerinfo from "@/components/CustomerInfo.vue";
import customercashaccount from "@/components/CustomerCashAccount.vue";
import customerbankaccount from "@/components/CustomerBankAccount.vue";
import cashaccountlogs from "@/views/Funds/CashAccountLogs.vue";
import bankaccountlogs from "@/views/Bank/BankAccountLogs.vue";
import editcustomer from "./components/CustomerEdit.vue";

export default {
  components: {
    search,
    orderlist,
    customerinfo,
    editcustomer,
    customercashaccount,
    customerbankaccount,
    cashaccountlogs,
    bankaccountlogs,
  },
  data () {
    return {
      loading: true,
      mso_id: 0,
      form: {
        mso_id: 0,
        coustomernum: '',
        old_customer_num: '',
        starttime: '',
        endtime: '',
        brstarttime: '',
        brendtime: '',
        type: '-1',
        status: '-1',
        phone: '',
        card: '',
        remarks: '',
        sortname: 'addtime',
        orderby: 'DESC',
      },
      customer_id: 0,
      show_info: false,
      edit_info: false,
      ordertype: -1,
      data: [],
      page: 1,
      pagesize: 10,
      pager: [],
      activename: 'info',
    };
  },
  methods: {
    del (id) {
      this.$confirm('確認刪除該數據嗎？', '詢問', {
        confirmButtonText: '確認',
        cancelButtonText: "取消",
        type: 'info'
      }).then(() => {
        this.post('/api/customer/delete', {
          id
        }).then(response => {
          if (response.status == 'success') {
            this.$notify({
              showClose: true,
              message: '刪除成功！',
              type: 'success',
              offset: 80
            });
            this.getdata();
          } else {
            this.$notify({
              showClose: true,
              message: '刪除失敗，請重試！',
              type: 'error',
              offset: 80
            });
          }
        }).catch(error => {
          console.log(error);
        })
      }).catch(() => {
      });
    },
    handleClick (tab, event) {
      this.activename = tab.name;
    },
    changestatus (id, status) {
      this.post('/api/customer/changestatus', {
        id, status
      }).then(response => {
        if (response.status == 'success') {
          this.$notify({
            showClose: true,
            message: '設置成功！',
            type: 'success',
            offset: 80
          });
        } else {
          this.$notify({
            showClose: true,
            message: '設置失敗，請重試！',
            type: 'error',
            offset: 80
          });
        }
      }).catch(error => {
        console.log(error);
      })
    },
    changerisk (id, risk_level) {
      this.post('/api/customer/changerisk', {
        id, risk_level
      }).then(response => {
        if (response.status == 'success') {
          this.$notify({
            showClose: true,
            message: '設置成功！',
            type: 'success',
            offset: 80
          });
        } else {
          this.$notify({
            showClose: true,
            message: '設置失敗，請重試！',
            type: 'error',
            offset: 80
          });
        }
      }).catch(error => {
        console.log(error);
      })
    },
    gotoruter (name) {
      this.$router.push(name)
    },
    changepage (val) {
      this.page = val;
      this.getdata();
    },
    changesize (val) {
      this.pagesize = val;
      this.getdata();
    },
    getdata () {
      this.loading = true;
      this.post('/api/customer/index', {
        page: this.page,
        pagesize: this.pagesize,
        ...this.form
      }).then((res) => {
        this.loading = false;
        if (res.info.length > 0) {
          let info = res.info;
          this.data = info;
          this.pager = res.pager;
          this.page = 1;
        } else {
          this.data = [];
          this.pager = [];
        }

      }).catch((err) => {
        console.log(err)
      })
    }

  },
  created () {
    this.mso_id = this.sessionRead('mso_id');
    this.form.mso_id = this.sessionRead('mso_id');
    this.getdata();
  },
  watch: {
    'form': { // 動態監控利率變化
      handler: function (val) {
        this.getdata();
      },
      deep: true
    },
  }
};
</script>
<style scoped>
.pagetablebox {
  padding: 20px 0;
}
.radio-group-box {
  display: flex;
  align-items: center;
}
.mb15 {
  margin-bottom: 15px;
}
.mr15 {
  margin-right: 15px;
}
.mt15 {
  margin-top: 15px;
}
.flex-center {
  display: flex;
  justify-content: space-between;
}

@media screen and (max-width: 1024px) {
  .mm-page-main {
    padding: 10px 20px !important;
  }
}
</style>
